import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CustomerResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CustomerResponseDataSchema>>

export type CustomerQueryOptions = {
  enabled?: boolean
}

export const getCustomerQueryKey = (id?: string) => ["customer", id].filter(Boolean)

export const customerQuery = (id: string, options: CustomerQueryOptions = {}) => {
  return queryOptions({
    queryKey: getCustomerQueryKey(id),
    queryFn: async () => {
      const response = await axios.get<Response>(`/customers/${id}`)

      return response.data.data
    },
    enabled: options.enabled,
    staleTime: 1000 * 60 * 2,
  })
}
